module.exports = __webpack_public_path__ + "static/media/logo.b9eb0f92.svg";